import PasswordTemplate from './PasswordTemplate'

export default PasswordTemplate
